module.exports = __webpack_public_path__ + "static/media/cellfinate_imagen_profesionales.3a18188a.jpg";